import { createCallableRouteInvoker } from '../../../../../shared/backend/transports/callable';
import { functions } from '@/lib/firebaseConfig';

export const invokeCallableRoute = createCallableRouteInvoker(functions);
